import gql from 'graphql-tag'

export default gql`
{
  labelGroup
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/labelGroup.js